import React from 'react';
import { DropdownContext } from './DropdownContext';
import { Button } from '../button/Button';
import { ButtonIcon } from '../button/ButtonIcon';
import { DropdownToggleType } from './types';
import Icon from '../icon/Icon';
import { COLORS } from '../colors';
import { acChevronDown } from 'ac-icon';
import classNames from 'classnames';
import { Avatar } from '../avatar/Avatar';
const DropdownToggle = ({ type, button, buttonIcon, buttonAvatar }) => {
    switch (type) {
        case DropdownToggleType.button: {
            const { color, size, iconSize, iconPath, iconPosition, className: classNameButtonText, children } = button;
            return (React.createElement(DropdownContext.Consumer, null, (value) => (React.createElement(Button, { disabled: value.disabled, size: size, id: value.id, type: 'button', color: color, iconPath: iconPath, iconSize: iconSize, iconPosition: iconPosition, isActive: value.isOpen, className: classNameButtonText }, children))));
        }
        case DropdownToggleType.buttonIcon: {
            const { iconPath, size, title, color, className: classNameButtonIcon } = buttonIcon;
            return (React.createElement(DropdownContext.Consumer, null, (value) => (React.createElement(React.Fragment, null,
                React.createElement(ButtonIcon, { iconPath: iconPath, color: color, size: size, title: title, id: value.id, disabled: value.disabled, className: classNameButtonIcon, isActive: value.isOpen })))));
        }
        case DropdownToggleType.buttonAvatar: {
            const { children, isTaskHeader, className: classNameButtonAvatar, imageUrl } = buttonAvatar;
            return (React.createElement(DropdownContext.Consumer, null, (value) => (React.createElement("button", { className: classNames('button-avatar', {
                    active: value.isOpen,
                    'is-task-header': isTaskHeader,
                }, classNameButtonAvatar), id: value.id, onMouseDown: (e) => e.preventDefault(), type: 'button', disabled: value.disabled },
                React.createElement("div", { className: 'button-avatar-img' },
                    React.createElement(Avatar, { size: 's', imageUrl: imageUrl })),
                React.createElement("span", { className: 'button-avatar-content' }, children),
                React.createElement("div", { className: 'button-avatar-icon' },
                    React.createElement(Icon, { path: acChevronDown, size: '16px', color: isTaskHeader ? COLORS.white : undefined, title: undefined }))))));
        }
    }
};
export { DropdownToggle };
//# sourceMappingURL=DropdownToggle.js.map